<div fxLayoutAlign.gt-md="space-between center">
  <h1>Inscrição #{{ id }}</h1>

  <div fxLayout="row" fxLayoutAlign="end start">
    <app-back-button (back)="voltar()"></app-back-button>
  </div>
</div>

<mat-tab-group #tabGroup mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Ficha de Inscrição">
    <mat-card>
      <mat-card-content>
        <div fxLayout="row" fxLayoutAlign="end center" *ngIf="showModoEdicao()">
          <mat-slide-toggle color="warn" [disabled]="!inscricaoEditavel" [checked]="edicaoFicha" (change)="modoEdicao()"
            >Modo edição</mat-slide-toggle
          >
        </div>

        <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
          <fieldset fxFlex="100%">
            <legend>Dados do inscrição</legend>

            <div fxLayout="column" fxLayoutGap="5px">
              <mat-form-field appearance="outline">
                <mat-label>Concurso</mat-label>
                <input matInput formControlName="tituloConcurso" name="tituloConcurso" [readonly]="true" />
              </mat-form-field>

              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Data</mat-label>
                  <input
                    matInput
                    formControlName="data"
                    name="data"
                    value="{{ form.controls['data'].value | date : 'dd/MM/yyyy HH:mm:ss' }}"
                    [readonly]="true" />
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="!isDepartamento">
                  <mat-label>Protocolo</mat-label>
                  <input matInput formControlName="protocolo" name="protocolo" [readonly]="true" />
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="inscricaoFicha?.valor != 0">
                  <mat-label>Pagamento</mat-label>
                  <input matInput formControlName="pago" name="pago" [readonly]="true" />
                </mat-form-field>
              </div>
            </div>
          </fieldset>

          <fieldset fxFlex="100%">
            <legend>Dados do candidato</legend>

            <div fxLayout="column" fxLayoutGap="5px">
              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Nome</mat-label>
                  <input matInput formControlName="nome" name="nome" />
                </mat-form-field>
              </div>
              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Nome social</mat-label>
                  <input matInput formControlName="nomeSocial" name="nomeSocial" />
                </mat-form-field>
              </div>
              <div>
                <app-arquivo-upload
                  label="Requerimento de nome social"
                  uploadPath="{{ 'inscricao/' + inscricaoFicha?.id + '/requerimentonomesocial' }}"
                  [fc]="requerimentoNomeSocialFc"
                  tip="Nenhum arquivo enviado."
                  [usarArquivoViewer]="true">
                </app-arquivo-upload>
              </div>
              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Data de nascimento</mat-label>
                  <input
                    matInput
                    readonly
                    [matDatepicker]="pickerDataNascimento"
                    [max]="today"
                    formControlName="dataNascimento"
                    name="dataNascimento" />
                  <mat-datepicker-toggle matSuffix [for]="pickerDataNascimento"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDataNascimento></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Estado Civil</mat-label>
                  <mat-select formControlName="estadoCivil" name="estadoCivil">
                    <mat-option *ngFor="let type of estadoCivil | keyvalue" [value]="type.key">
                      {{ type.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Sexo</mat-label>
                  <mat-select formControlName="sexo" name="sexo">
                    <mat-option *ngFor="let type of sexo | keyvalue" [value]="type.key">
                      {{ type.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field
                  appearance="outline"
                  *ngIf="this.form.get('sexo')?.value?.toUpperCase() === sexo.OUTRO.toUpperCase()">
                  <mat-label>Identidade de Gênero</mat-label>
                  <input matInput formControlName="identidadeGenero" name="identidadeGenero" />
                </mat-form-field>
              </div>

              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Nome da mãe</mat-label>
                  <input matInput formControlName="nomeMae" name="nomeMae" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Nome do pai</mat-label>
                  <input matInput formControlName="nomePai" name="nomePai" />
                </mat-form-field>
              </div>

              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Profissão</mat-label>
                  <input matInput formControlName="profissao" name="profissao" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Grau de escolaridade</mat-label>
                  <mat-select formControlName="escolaridade" name="escolaridade">
                    <mat-option *ngFor="let type of grauEscolaridade | keyvalue" [value]="type.key">{{
                      type.value
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Estrangeiro</mat-label>
                  <mat-select formControlName="estrangeiro" name="estrangeiro" (selectionChange)="validaEstrangeiro()">
                    <mat-option *ngFor="let type of estrangeiro | keyvalue" [value]="type.key">
                      {{ type.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>CPF</mat-label>
                  <input matInput formControlName="cpf" name="cpf" mask="000.000.000-00" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Passaporte</mat-label>
                  <input matInput formControlName="passaporte" name="passaporte" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>RNE/RNM</mat-label>
                  <input matInput formControlName="rne" name="rne" maxlength="12" (blur)="onRneInput($event)"/>
                </mat-form-field>
              </div>

              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>RG</mat-label>
                  <input
                    class="form-control"
                    maxlength="13"
                    type="text"
                    matInput
                    formControlName="rg"
                    name="rg"
                    mask="A{13}" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>UF</mat-label>
                  <mat-select formControlName="uf" name="uf">
                    <mat-option *ngFor="let type of estado | keyvalue" [value]="type.key">
                      {{ type.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Data de expedição</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerExpedicao"
                    [max]="today"
                    placeholder="dd/mm/aaaa"
                    class="datepicker form-control"
                    type="text"
                    formControlName="dataExpedicao"
                    name="dataExpedicao" />
                  <mat-datepicker-toggle matSuffix [for]="pickerExpedicao"></mat-datepicker-toggle>
                  <mat-datepicker #pickerExpedicao></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Orgão</mat-label>
                  <mat-select formControlName="orgaoExpedicao" name="orgaoExpedicao">
                    <mat-option *ngFor="let type of orgaoExpedicaoRg | keyvalue" [value]="type.key">
                      {{ type.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <app-arquivo-upload
              label="Documento de identificação"
              uploadPath="{{ 'inscricao/' + inscricaoFicha?.id + '/documentoidentificacao' }}"
              [fc]="documentoIdentificacaoFc"
              tip="Nenhum arquivo enviado."
              [usarArquivoViewer]="true">
            </app-arquivo-upload>
          </fieldset>

          <fieldset fxFlex="100%">
            <legend>Local do nascimento</legend>

            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline">
                <mat-label>País</mat-label>
                <input matInput formControlName="pais" name="pais" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Estado</mat-label>
                <input matInput formControlName="estado" name="estado" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="cidade" name="cidade" />
              </mat-form-field>
            </div>
          </fieldset>

          <fieldset fxFlex="100%">
            <legend>Informações de contato</legend>

            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
              <mat-form-field appearance="outline">
                <mat-label>Celular</mat-label>
                <input
                  *ngIf="!form.get('celular')?.value?.includes('+') || form.get('celular')?.value?.startsWith('+55'); else noMask"
                  matInput
                  mask="(00) 00000-0000"
                  [dropSpecialCharacters]="true"
                  [validation]="false"
                  formControlName="celular"
                  name="celular"
                  type="text"
                  maxlength="16" />
                  <ng-template #noMask>
                    <input
                      matInput
                      class="form-control celular"
                      type="text"
                      formControlName="celular"
                      name="celular"
                      maxlength="20" />
                  </ng-template>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Telefone</mat-label>
                <input
                  *ngIf="!form.get('telefone')?.value?.includes('+') || form.get('telefone')?.value?.startsWith('+55'); else noMaskTel"
                  matInput
                  mask="(00) 0000-0000"
                  [dropSpecialCharacters]="false"
                  formControlName="telefone"
                  name="telefone"
                  type="text"
                  maxlength="14" />
                  <ng-template #noMaskTel>
                    <input
                      matInput
                      class="form-control telefone"
                      type="text"
                      formControlName="telefone"
                      maxlength="20" />
                  </ng-template>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="email" name="email" />
              </mat-form-field>
            </div>
          </fieldset>

          <fieldset fxFlex="100%">
            <legend>Endereço</legend>

            <div fxLayout="column" fxLayoutGap="5px">
              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>País</mat-label>
                  <input matInput formControlName="enderecoPais" name="enderecoPais" />
                </mat-form-field>

                <ng-container
                  *ngIf="
                    form.get('enderecoPais')?.value === 'Brasil';
                    then contextoNacional;
                    else contextoInternacional
                  ">
                </ng-container>
                <ng-template #contextoNacional>
                  <mat-form-field appearance="outline">
                    <mat-label>CEP</mat-label>
                    <input
                      matInput
                      formControlName="enderecoCep"
                      name="enderecoCep"
                      (blur)="validaCEP()"
                      mask="00.000-000"
                      [dropSpecialCharacters]="false" />
                  </mat-form-field>
                </ng-template>
                <ng-template #contextoInternacional>
                  <mat-form-field appearance="outline">
                    <mat-label>CEP</mat-label>
                    <input
                      matInput
                      formControlName="enderecoCep"
                      name="enderecoCep"
                      (blur)="validaCEP()" />
                  </mat-form-field>
                </ng-template>
              </div>
              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Logradouro</mat-label>
                  <input matInput formControlName="enderecoLogradouro" name="enderecoLogradouro" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Número</mat-label>
                  <input matInput formControlName="enderecoNumero" name="enderecoNumero" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Complemento</mat-label>
                  <input matInput formControlName="enderecoComplemento" name="enderecoComplemento" />
                </mat-form-field>
              </div>

              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Bairro</mat-label>
                  <input matInput formControlName="enderecoBairro" name="enderecoBairro" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Cidade</mat-label>
                  <input matInput formControlName="enderecoCidade" name="enderecoCidade" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Estado</mat-label>
                  <input matInput formControlName="enderecoEstado" name="enderecoEstado" />
                </mat-form-field>
              </div>
            </div>
          </fieldset>
          <fieldset fxFlex="100%">
            <legend>Atendimento Especial</legend>
            <div fxLayout="column" fxLayoutGap="5px">
              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Canhoto</mat-label>
                  <mat-select formControlName="canhoto" name="canhoto">
                    <mat-option value="false">Não</mat-option>
                    <mat-option value="true">Sim</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Lactante</mat-label>
                  <mat-select formControlName="lactante" name="lactante">
                    <mat-option value="false">Não</mat-option>
                    <mat-option value="true">Sim</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Possui alguma outra necessidade especial</mat-label>
                  <mat-select formControlName="possuiOutraNecessidade" name="possuiOutraNecessidade">
                    <mat-option value="false">Não</mat-option>
                    <mat-option value="true">Sim</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <mat-form-field appearance="outline">
                <mat-label>Recursos especiais necessários para a realização das provas</mat-label>
                <textarea
                  matInput
                  formControlName="atendimentoEspecialNecessidadesProva"
                  name="atendimentoEspecialNecessidadesProva"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"></textarea>
              </mat-form-field>
              <app-arquivo-upload
                label="Laudo médico da outra necessidade especial"
                uploadPath="{{ 'inscricao/' + inscricaoFicha?.id + '/laudomedicoatendimentoespecial' }}"
                accept="application/pdf"
                [fc]="laudoMedicoAtendimentoEspecialFc"
                tip="Nenhum arquivo enviado."
                [usarArquivoViewer]="true">
              </app-arquivo-upload>
            </div>
          </fieldset>
          <fieldset fxFlex="100%">
            <legend>PcD</legend>
            <div fxLayout="column" fxLayoutGap="5px">
              <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
                <mat-form-field appearance="outline">
                  <mat-label>Possui alguma deficiência</mat-label>
                  <mat-select formControlName="possuiDeficiencia" name="possuiDeficiencia">
                    <mat-option value="false">Não</mat-option>
                    <mat-option value="true">Sim</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Deficiências</mat-label>
                  <mat-select formControlName="deficiencia" name="deficiencia" multiple="true">
                    <mat-option *ngFor="let type of deficiencia | keyvalue" [value]="type.key">{{
                      type.value
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Deseja concorrer como deficiente</mat-label>
                  <mat-select formControlName="concorrerVagaDeficiente" name="concorrerVagaDeficiente">
                    <mat-option value="false">Não</mat-option>
                    <mat-option value="true">Sim</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <mat-form-field appearance="outline">
                <mat-label>Recursos especiais PcD necessários para a realização das provas</mat-label>
                <textarea
                  matInput
                  formControlName="deficienciaNecessidadesProva"
                  name="deficienciaNecessidadesProva"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"></textarea>
              </mat-form-field>
              <app-arquivo-upload
                label="Laudo médico da deficiência"
                uploadPath="{{ 'inscricao/' + inscricaoFicha?.id + '/laudomedicodeficiencia' }}"
                accept="application/pdf"
                [fc]="laudoMedicoPcdFc"
                tip="Nenhum arquivo enviado."
                [usarArquivoViewer]="true">
              </app-arquivo-upload>
            </div>
          </fieldset>
          <fieldset fxFlex="100%" *ngIf="tipoConcurso?.localeCompare('PTPP') === 0">
            <legend>Autodeclaração</legend>
            <mat-form-field appearance="outline">
              <mat-label>Me autodeclaro pessoa: </mat-label>
              <mat-select formControlName="autodeclaracao" name="autodeclaracao">
                <mat-option *ngFor="let type of autodeclaracao | keyvalue" [value]="type.key">{{
                  type.value
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </fieldset>
          <fieldset fxFlex="100%">
            <legend>Outros</legend>
            <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>

              <mat-form-field appearance="outline">
                <mat-label>Prova em inglês</mat-label>
                <mat-select formControlName="provaIngles" name="provaIngles">
                  <mat-option value="false">Não</mat-option>
                  <mat-option value="true">Sim</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" *ngIf="tipoConcurso?.localeCompare('TECADM') === 0">
              <mat-label
                >Se autodeclara pessoa preta, parda ou indígena de acordo com a Resolução UNESP nº 86 de
                25/08/2023?</mat-label
              >
              <mat-select formControlName="autodeclaraRaca" name="autodeclaraRaca">
                <mat-option value="false">Não</mat-option>
                <mat-option value="true">Sim</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="tipoConcurso?.localeCompare('TECADM') === 0">
              <mat-label
                >Deseja utilizar o sistema de pontuação diferenciada nas notas finais em todas as provas escritas,
                aplicada à pessoa preta, parda ou indígena?</mat-label
              >
              <mat-select formControlName="pontuacaoDiferenciada" name="pontuacaoDiferenciada">
                <mat-option value="false">Não</mat-option>
                <mat-option value="true">Sim</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="tipoConcurso?.localeCompare('TECADM') === 0">
              <mat-label>Me autodeclaro pessoa: </mat-label>
              <mat-select formControlName="autodeclaracao" name="autodeclaracao">
                <mat-option *ngFor="let type of autodeclaracao | keyvalue" [value]="type.key">{{
                  type.value
                }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="tipoConcurso?.localeCompare('TECADM') === 0">
              <mat-label>Confirmação de veracidade</mat-label>
              <mat-select formControlName="declaracaoVeracidade" name="declaracaoVeracidade">
                <mat-option value="false">Não</mat-option>
                <mat-option value="true">Sim</mat-option>
              </mat-select>
            </mat-form-field>
          </fieldset>
          <fieldset fxFlex="100%" *ngIf="temas.length > 0">
            <legend>Pontos</legend>
            <mat-form-field appearance="outline">
              <mat-label>Pontos</mat-label>
              <mat-select formControlName="temas" name="temas" multiple="true">
                <mat-option *ngFor="let value of temas" [value]="value">{{ value }}</mat-option>
              </mat-select>
            </mat-form-field>
          </fieldset>
        </form>
      </mat-card-content>
      <mat-card-actions>
        <div
          fxLayoutAlign.gt-md="space-between center"
          fxLayoutAlign.lt-md="center stretch"
          fxLayout.lt-md="column"
          fxLayoutGap="20px">
          <button mat-raised-button color="primary" (click)="gravar()" [disabled]="!edicaoFicha" *ngIf="showModoEdicao()">
            <mat-icon>edit</mat-icon> Atualizar
          </button>
          <button
            *ngIf="!shouldHideDownloadPrintIcons"
            mat-raised-button
            color="primary"
            (click)="imprimir()">
            <mat-icon>print</mat-icon> Imprimir
          </button>
          <app-cancel-button (cancel)="voltar()"></app-cancel-button>
        </div>
      </mat-card-actions>
    </mat-card>
  </mat-tab>

  <mat-tab *ngIf="mapGruposComplementos.size > 0 && showTabAnexos()" label="Complementos">
    <mat-card>
      <mat-card-content fxLayout="column" fxLayoutGap="20px">
        <div fxLayout="row" fxLayoutAlign="end center">
          <mat-slide-toggle
            color="warn"
            [disabled]="!inscricaoEditavel && !isPeriodoSegundaFase"
            [checked]="edicaoComplementos"
            (change)="modoEditarComplementos()"
            >Modo edição</mat-slide-toggle
          >
        </div>
        <span class="complementos-status" [ngClass]="complementosInscricaoStatus">{{
          complementosInscricaoStatusMsg
        }}</span>
        <span *ngIf="temSegundaFase" class="complementos-status" [ngClass]="complementosSegundaFaseStatus">{{
          complementosSegundaFaseStatusMsg
        }}</span>
        <fieldset fxFlex="100%">
          <legend>Informações Complementares</legend>
          <app-informacao-complementar-grupo
            *ngFor="let g of mapGruposComplementos | keyvalue : asIsOrder; let first = first"
            [formGroup]="formComplementar"
            [grupo]="g.key"
            [complementos]="g.value"
            [primeiroGrupo]="first"
            [idInscricao]="id"
            [codigoOrgao]="inscricaoFicha?.codigoOrgao">
          </app-informacao-complementar-grupo>
        </fieldset>
      </mat-card-content>
    </mat-card>
  </mat-tab>

  <mat-tab *ngIf="showTabReducao()" label="Redução">
    <ng-template matTabContent>
      <app-inscricao-reducao></app-inscricao-reducao>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="showTabPagamento()" label="Pagamento">
    <ng-template matTabContent>
      <app-inscricao-pagamento></app-inscricao-pagamento>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="showTabDevolucao()" label="Devolução">
    <ng-template matTabContent>
      <app-inscricao-pagamento-devolucao></app-inscricao-pagamento-devolucao>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="showTabSituacao()" label="Situação">
    <ng-template matTabContent>
      <app-inscricao-situacao (cancelar)="voltar()"></app-inscricao-situacao>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="documentos.length > 0 && showTabDocumentos()" label="Documentos">
    <ng-template matTabContent>
      <app-inscricao-documentos [documentos]="documentos"></app-inscricao-documentos>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="anexos.length > 0 && showTabAnexos()" label="Anexos">
    <ng-template matTabContent>
      <app-inscricao-anexos
        [anexos]="anexos"
        [idInscricao]="id"
        [idConcurso]="inscricaoFicha?.idConcurso"
        [codigoOrgao]="inscricaoFicha?.codigoOrgao"
        [hideDownloadPrintIcons]="shouldHideDownloadPrintIcons">
      </app-inscricao-anexos>
    </ng-template>
  </mat-tab>

  <mat-tab *ngIf="showTabHistorico()" label="Histórico de alterações">
    <ng-template matTabContent>
      <mat-card>
        <mat-card-content>
          <!-- Texto informativo minimizado -->
          <div style="background-color: #f5f5f5; border-left: 4px solid #1976d2; border-radius: 4px; margin-bottom: 20px; overflow: hidden;">
            <div 
              (click)="toggleHistoricoInfo()" 
              style="padding: 16px; cursor: pointer; display: flex; justify-content: space-between; align-items: center; user-select: none;"
              [style.border-bottom]="historicoInfoExpanded ? '1px solid #ddd' : 'none'">
              <h3 style="margin: 0; color: #1976d2; font-size: 16px; font-weight: 500;">
                <mat-icon style="vertical-align: middle; margin-right: 8px; font-size: 20px;">info</mat-icon>
                Sobre o Histórico de Alterações
              </h3>
              <mat-icon style="color: #1976d2; transition: transform 0.3s;" [style.transform]="historicoInfoExpanded ? 'rotate(180deg)' : 'rotate(0deg)'">
                expand_more
              </mat-icon>
            </div>
            <div *ngIf="historicoInfoExpanded" style="padding: 0 16px 16px 16px; animation: slideDown 0.3s ease-out;">
              <p style="margin: 0 0 8px 0; line-height: 1.6; color: #555;">
                Esta página registra todas as ações realizadas pelo candidato nesta inscrição, incluindo:
              </p>
              <ul style="margin: 8px 0 12px 20px; line-height: 1.8; color: #555;">
                <li><strong>Alterações na ficha de inscrição:</strong> modificações em dados pessoais, endereço e informações complementares</li>
                <li><strong>Upload de documentos:</strong> envio de laudos médicos, comprovantes e anexos obrigatórios</li>
                <li><strong>Outras operações:</strong> ações relacionadas ao processo de inscrição</li>
              </ul>
              <p style="margin: 0 0 8px 0; line-height: 1.6; color: #555;">
                <strong>ID Log:</strong> Cada ação possui um número único de identificação. Quando um candidato relatar algum problema, solicite que ele envie um print da tela mostrando o erro completo da ação. Isso permitirá rastrear rapidamente o registro exato da operação realizada pelo candidato.
              </p>
              <p style="margin: 0; line-height: 1.6; color: #555;">
                <strong>Comprovação de estabilidade:</strong> Para ações de upload, você pode verificar se outros candidatos realizaram operações similares no mesmo período (30 minutos antes e depois). Isso ajuda a identificar se eventuais problemas foram isolados ou afetaram múltiplos usuários.
              </p>
            </div>
          </div>

          <div *ngIf="historicoLogs.length === 0 && !historicoLoading && historicoTotalElements === 0" style="padding: 16px; text-align: center; color: #666;">
            Nenhum registro de histórico encontrado para esta inscrição.
          </div>

          <div *ngIf="historicoLoading" style="padding: 16px; text-align: center;">
            <mat-spinner diameter="32" style="margin: 0 auto;"></mat-spinner>
          </div>

          <table *ngIf="historicoLogs.length > 0" mat-table [dataSource]="historicoLogs" class="mat-elevation-z0" style="width: 100%;">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID Log</th>
              <td mat-cell *matCellDef="let log">{{ log.id }}</td>
            </ng-container>

            <ng-container matColumnDef="dataHora">
              <th mat-header-cell *matHeaderCellDef>Data e Hora</th>
              <td mat-cell *matCellDef="let log">{{ log.dataHora | date:'dd/MM/yyyy HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="acao">
              <th mat-header-cell *matHeaderCellDef>Ação</th>
              <td mat-cell *matCellDef="let log">{{ traduzirAcao(log.acao) }}</td>
            </ng-container>

            <ng-container matColumnDef="registro">
              <th mat-header-cell *matHeaderCellDef>Registro</th>
              <td mat-cell *matCellDef="let log">{{ log.registroId ? '#' + log.registroId : '' }}</td>
            </ng-container>

            <ng-container matColumnDef="resultado">
              <th mat-header-cell *matHeaderCellDef>Resultado</th>
              <td mat-cell *matCellDef="let log">
                <span [style.color]="extrairSucessoFalha(log).sucesso ? 'green' : 'red'">
                  {{ extrairSucessoFalha(log).sucesso ? 'Sucesso' : 'Falha' }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="motivo">
              <th mat-header-cell *matHeaderCellDef>Motivo</th>
              <td mat-cell *matCellDef="let log">{{ extrairSucessoFalha(log).motivo }}</td>
            </ng-container>

            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let log">
                <button *ngIf="isLogUpload(log)" mat-stroked-button (click)="abrirEstabilidade(log)" aria-label="Comprovação de estabilidade">
                  <mat-icon>verified</mat-icon> Comprovação de estabilidade
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="['id', 'dataHora', 'acao', 'registro', 'resultado', 'motivo', 'acoes']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['id', 'dataHora', 'acao', 'registro', 'resultado', 'motivo', 'acoes'];"></tr>
          </table>

          <div *ngIf="historicoLogs.length > 0" style="display: flex; justify-content: space-between; align-items: center; padding: 8px 16px;">
            <span>Página {{ historicoPage + 1 }} — {{ historicoTotalElements }} registros</span>
            <div>
              <button mat-icon-button [disabled]="historicoPage === 0" (click)="onHistoricoPaginaAnterior()">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <button mat-icon-button [disabled]="(historicoPage + 1) * historicoPageSize >= historicoTotalElements" (click)="onHistoricoProximaPagina()">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          </div>

          <!-- Comprovação de estabilidade -->
          <div *ngIf="estabilidadeLogRef" #estabilidadeSection style="margin-top: 16px; border: 1px solid #ccc; border-radius: 4px; padding: 16px;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
              <h3 style="margin: 0;">Comprovação de estabilidade — Log #{{ estabilidadeLogRef.id }}</h3>
              <div>
                <button mat-raised-button color="primary" (click)="copiarEstabilidade()" [disabled]="estabilidadeLogs.length === 0" style="margin-right: 8px;">
                  <mat-icon>content_copy</mat-icon> Copiar
                </button>
                <button mat-icon-button (click)="fecharEstabilidade()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
            <p style="color: #666; margin-bottom: 12px;">
              Ações similares no sistema (meia hora antes e meia hora depois): {{ estabilidadeInicio() | date:'dd/MM/yyyy HH:mm:ss' }} a {{ estabilidadeFim() | date:'dd/MM/yyyy HH:mm:ss' }}.
              <span style="font-weight: 500;">Linhas destacadas</span> pertencem a esta inscrição.
            </p>

            <div *ngIf="estabilidadeLoading" style="text-align: center; padding: 16px;">
              <mat-spinner diameter="32" style="margin: 0 auto;"></mat-spinner>
            </div>

            <div *ngIf="!estabilidadeLoading && estabilidadeLogs.length === 0" style="text-align: center; padding: 16px; color: #666;">
              Nenhuma ação similar encontrada no período. Isso pode indicar instabilidade isolada.
            </div>

            <table *ngIf="estabilidadeLogs.length > 0" mat-table [dataSource]="estabilidadeLogs" class="mat-elevation-z0" style="width: 100%;">
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>ID Log</th>
                <td mat-cell *matCellDef="let l">{{ l.id }}</td>
              </ng-container>
              <ng-container matColumnDef="dataHora">
                <th mat-header-cell *matHeaderCellDef>Data e Hora</th>
                <td mat-cell *matCellDef="let l">{{ l.dataHora | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              </ng-container>
              <ng-container matColumnDef="inscricaoId">
                <th mat-header-cell *matHeaderCellDef>Inscrição</th>
                <td mat-cell *matCellDef="let l">{{ l.registroPai || l.registroId }}</td>
              </ng-container>
              <ng-container matColumnDef="acao">
                <th mat-header-cell *matHeaderCellDef>Ação</th>
                <td mat-cell *matCellDef="let l">{{ traduzirAcao(l.acao) }}</td>
              </ng-container>
              <ng-container matColumnDef="resultado">
                <th mat-header-cell *matHeaderCellDef>Sucesso/Falha</th>
                <td mat-cell *matCellDef="let l">
                  <span [style.color]="extrairSucessoFalha(l).sucesso ? 'green' : 'red'">
                    {{ extrairSucessoFalha(l).sucesso ? 'Sucesso' : 'Falha' }}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="motivo">
                <th mat-header-cell *matHeaderCellDef>Motivo da falha</th>
                <td mat-cell *matCellDef="let l">{{ extrairSucessoFalha(l).motivo }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="['id', 'dataHora', 'inscricaoId', 'acao', 'resultado', 'motivo']"></tr>
              <tr mat-row *matRowDef="let row; columns: ['id', 'dataHora', 'inscricaoId', 'acao', 'resultado', 'motivo'];"
                [class.estabilidade-inscricao-atual]="isLogDaInscricaoAtual(row)"
                [class.estabilidade-log-referencia]="row.id === estabilidadeLogRef?.id"></tr>
            </table>

            <div *ngIf="estabilidadeLogs.length > 0" style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; flex-wrap: wrap; gap: 4px;">
              <span>{{ estabilidadeTotalElements }} registros</span>
              <div style="display: flex; align-items: center; gap: 2px;">
                <button mat-icon-button [disabled]="estabilidadePage === 0" (click)="onEstabilidadePaginaAnterior()">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <button *ngFor="let p of estabilidadePages"
                  mat-button
                  [color]="p === estabilidadePage ? 'primary' : ''"
                  [style.font-weight]="p === estabilidadePage ? '700' : '400'"
                  [style.min-width]="'36px'"
                  [style.text-decoration]="p === estabilidadeRefPage ? 'underline' : 'none'"
                  (click)="irParaPaginaEstabilidade(p)">
                  {{ p + 1 }}
                </button>
                <button mat-icon-button [disabled]="estabilidadePage >= estabilidadeTotalPages - 1" (click)="onEstabilidadeProximaPagina()">
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </mat-tab>

</mat-tab-group>
